import { render, staticRenderFns } from "./PropertyPremises.vue?vue&type=template&id=004d9548&"
import script from "./PropertyPremises.vue?vue&type=script&lang=js&"
export * from "./PropertyPremises.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports